<template>
  <b-form class="person-form">
    <b-form-group label="Фамилия">
      <b-form-input
        v-model="value.surname"
        type="text"
        placeholder="Введите фамилию"
      />
    </b-form-group>
    <b-form-group label="Имя">
      <b-form-input
        v-model="value.name"
        type="text"
        placeholder="Введите имя"
      />
    </b-form-group>
    <b-form-group label="Отчество">
      <b-form-input
        v-model="value.patronymic"
        type="text"
        placeholder="Введите отчество"
      />
    </b-form-group>
    <b-form-group label="Пол">
      <b-form-select
        v-model="value.sex"
        :options="[
          { text: 'Мужской', value: 1 },
          { text: 'Женский', value: 0 }
        ]"
        required
      />
    </b-form-group>
    <b-form-group label="Дата рождения">
      <datepicker
        v-model="value.birthday"
        placeholder="Введите дату рождения (дд.мм.гггг)"
        button-variant="primary"
      />
    </b-form-group>
    <b-form-group label="Адрес электронной почты">
      <b-form-input
        v-model="value.email"
        type="email"
        placeholder="Введите адрес электронной почты"
      />
    </b-form-group>
    <b-form-group label="Номера телефонов">
      <b-input-group
        v-for="(phone, index) in value.phones"
        :key="index"
        class="person-form__phone-number-editor"
      >
        <phone-editor :value="phone" />
        <b-input-group-append right>
          <b-button
            class="person-form__phone-number-editor__remove-button"
            variant="danger"
            v-b-popover.hover="'Удалить номер телефона'"
            @click="removePhone(phone)"
          >
            <b-icon icon="x-square" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-button
        variant="primary"
        class="person-form__button add-phone-number-button"
        @click="addPhone"
      >
        Добавить номер телефона
      </b-button>
    </b-form-group>
    <b-form-group label="Комментарии">
      <b-input-group
        v-for="(comment, index) in value.comments"
        :key="index"
        class="person-form__comment-editor"
      >
        <b-input
          v-model="comment.comment"
          type="text"
          placeholder="Введите комментарий"
          required
        />
        <b-input-group-append right>
          <b-button
            class="person-form__comment-editor__remove-button"
            variant="danger"
            v-b-popover.hover="'Удалить комментарий'"
            @click="removeComment(comment)"
          >
            <b-icon icon="x-square" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-button
      variant="primary"
      class="person-form__button add-comment-number-button"
      @click="addComment"
    >
      Добавить комментарий
    </b-button>
    <b-form-checkbox v-model="isEmployee">
      Работник предприятия
    </b-form-checkbox>
    <b-collapse v-model="isEmployee">
      <h5 class="text-center">Данные о работнике предприятия</h5>
      <employee-form v-model="employeeData" />
    </b-collapse>
    <b-form-checkbox v-model="isUnionMember">
      Член профсоюза
    </b-form-checkbox>
    <b-collapse v-model="isUnionMember">
      <h5 class="text-center">Данные о члене профсоюза</h5>
      <union-member-form v-model="unionMemberData" />
    </b-collapse>
    <b-form-checkbox
      v-model="value.vip_status"
      v-if="hasRole(['root', 'admin'])"
    >
      VIP статус
    </b-form-checkbox>
  </b-form>
</template>

<script>
import Datepicker from "@/components/Datepicker";
import PhoneEditor from "@/components/Forms/Person/PhoneEditor";
import EmployeeForm from "@/components/Forms/Person/EmployeeForm";
import UnionMemberForm from "@/components/Forms/Person/UnionMemberForm";
import PersonModel from "@/components/Forms/Person/models/personModel";
import EmployeeModel from "@/components/Forms/Person/models/employeeModel";
import UnionMemberModel from "@/components/Forms/Person/models/unionMemberModel";
import { mapGetters } from "vuex";

export default {
  components: { UnionMemberForm, EmployeeForm, PhoneEditor, Datepicker },
  props: {
    value: {
      type: PersonModel,
      required: false,
      default: () => new PersonModel()
    }
  },
  data() {
    return {
      isEmployee: false,
      isUnionMember: false,
      employeeData: new EmployeeModel(),
      unionMemberData: new UnionMemberModel()
    };
  },
  computed: {
    ...mapGetters("user", ["hasRole"])
  },
  methods: {
    addPhone() {
      this.value.phones.push({
        phone_number: "+7",
        has_telegram: 0,
        has_whatsapp: 0,
        has_viber: 0
      });
    },
    removePhone(phone) {
      this.value.phones.splice(this.value.phones.indexOf(phone), 1);
    },
    addComment() {
      this.value.comments.push({ comment: null });
    },
    removeComment(comment) {
      this.value.comments.splice(this.value.comments.indexOf(comment), 1);
    },
    update(value) {
      this.isEmployee = value.employee_data !== null;
      this.isUnionMember = value.union_member_data !== null;

      this.employeeData =
        value.employee_data === null
          ? new EmployeeModel()
          : value.employee_data;
      this.unionMemberData =
        value.union_member_data === null
          ? new UnionMemberModel()
          : value.union_member_data;
    }
  },
  watch: {
    isEmployee: {
      handler(val) {
        this.value.employee_data = val ? this.employeeData : null;
      }
    },
    isUnionMember: {
      handler(val) {
        this.value.union_member_data = val ? this.unionMemberData : null;
      }
    },
    value: {
      handler(value) {
        this.update(value);
      }
    }
  },
  created() {
    this.update(this.value);
  }
};
</script>

<style lang="scss">
.person-form {
  &__button {
    display: block;
    width: 100%;
    margin: 5px 0;
  }
  &__phone-number-editor {
    display: flex;
    border-radius: 0.25rem;
    border: solid 1px #ced4da;
    margin-bottom: 5px;
    .phone-editor {
      margin-bottom: 0;
      flex-grow: 1;
      input[type="tel"] {
        border: 0;
        border-radius: 0.25rem 0 0 0;
        border-bottom: solid 1px #ced4da;
      }
    }
    &__remove-button {
      margin: -1px;
      border-radius: 0.25rem;
    }
  }
  &__comment-editor {
    margin-top: 5px;
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
